import { useGetBannerNotifications } from './useGetBannerNotifications';
import { BannerNotification } from './BannerNotification';
import { bannerContainerId } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const containerId = 'notificationBannerContainer';
const BannerNotificationsContainer = () => {
  const notifications = useGetBannerNotifications();
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": bannerContainerId,
    id: bannerContainerId,
    children: notifications.map(notification => {
      return /*#__PURE__*/_jsx(BannerNotification, {
        notification: notification
      }, notification.id);
    })
  });
};
export default BannerNotificationsContainer;